/**
 * Unwrap JSON:API (or plain) company edit request from GET/PATCH response.
 */
export function normalizeCompanyEditRequestResponse(response) {
  const top = response?.data?.data ?? response?.data;
  const resource = top?.data ?? top;
  if (!resource) return null;
  if (resource.attributes && typeof resource.attributes === "object") {
    const a = resource.attributes;
    return {
      ...a,
      requestApiId: resource.id != null ? resource.id : a.id,
    };
  }
  return resource;
}
